import React, { FC } from 'react'
import { Box, useTheme } from '@mui/material'
import { Bar } from '../../Bar/bar.component'

interface IBaseScreenProps {
    children: React.ReactNode
    withSideBar?: boolean
    variant?: 'default' | 'light'
}

const BaseScreen: FC<IBaseScreenProps> = ({ children, variant = 'default' }) => {
    const theme = useTheme()
    const isLight = variant === 'light'

    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: '100%',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                backgroundColor: isLight ? theme.palette.background.default : theme.palette.primary.main,
            }}
        >
            <Box sx={{ flexShrink: 0 }}>
                <Bar />
            </Box>

            <Box
                component="main"
                sx={{
                    flex: 1,
                    width: '100%',
                    minHeight: 0,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    padding: isLight ? { xs: 1.5, md: 2 } : 2.5,
                }}
            >
                {children}
            </Box>
        </Box>
    )
}

export { BaseScreen }
